import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Mission } from "@/components/Mission";
import { Learning } from "@/components/Learning";
import { Team } from "@/components/Team";
import { Advisors } from "@/components/Advisors";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { ComingSoon } from "@/components/ComingSoon";
import { Toaster } from "@/components/ui/sonner";

// Toggle between Coming Soon and Full Site
// Set REACT_APP_COMING_SOON=true in .env to show coming soon page
const SHOW_COMING_SOON = process.env.REACT_APP_COMING_SOON === 'true';

const FullSite = () => {
  return (
    <div>
      <Header />
      <Hero />
      <Mission />
      <Learning />
      <Team />
      <Advisors />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

const Home = () => {
  return SHOW_COMING_SOON ? <ComingSoon /> : <FullSite />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route index element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
